import type { ContractNature, MainCpvRuleDto } from "../../autogen/bff-api";

export type FitsAsMainCode = (code: string) => boolean;

export const fitsAsMainCode = (
  rules: MainCpvRuleDto[],
  contractNature: ContractNature | null | undefined,
): FitsAsMainCode | null => {
  const prefixes = contractNature ? rules.find((rule) => rule.contractNature === contractNature)?.prefixes : undefined;
  return prefixes ? (code) => prefixes.some((prefix) => code.startsWith(prefix)) : null;
};

export const everyCodeFits: FitsAsMainCode = () => true;

export const withMainCodeFirst = (codes: string[], fits: FitsAsMainCode): string[] => {
  if (codes.length === 0 || fits(codes[0])) return codes;
  const main = codes.find(fits);
  return main ? asMainCode(codes, main) : codes;
};

export const asMainCode = (codes: string[], code: string): string[] => [code, ...codes.filter((c) => c !== code)];
